<template lang="html">
  <root class="admin-push-notifications">
    <admin-nav></admin-nav>
    <page-header name="Push Notifications" :count="false"></page-header>
    <!-- Data -->
    <div class="container">
      <div class="row">
        <div class="col m8 offset-m2">

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Title (EN)</label>
                <input type="text" v-model="headings.en">
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Title (AR)</label>
                <input type="text" v-model="headings.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Message (EN)</label>
                <textarea class="materialize-textarea"  v-model="contents.en"></textarea>
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Message (AR)</label>
                <textarea class="materialize-textarea" v-model="contents.ar"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-textfield">
                <label>Tip</label>
                <p>If you want to use emojis, copy emoji from <a href="https://www.emojicopy.com/" target="_blank">EmojiCopy</a> and paste to title or message fields.</p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col m2 offset-m5">
          <a class="waves-effect waves-light btn" @click="send()" :disabled="isSending">Send</a>
        </div>
      </div>
    </div>
  </root>
</template>

<script>
import config from "../../../app.config.json"
import * as axios from 'axios'

export default {
  data () {
    return {
      headings: {
        en: '',
        ar: '',
      },
      contents: {
        en: '',
        ar: '',
      },

      isSending: false
    }
  },

  methods: {
    send () {

      // All fields required
      if (!this.headings.en || !this.headings.ar || !this.contents.en || !this.contents.ar) {
        Materialize.toast('All fields are required', 4000)
        return
      }

      let userLangs = ['en', 'ar']
      this.isSending = true

      userLangs.forEach( userLang => {
        var data = {
          "app_id": config.onesignal_api[config.app.env]["app_id"],
          "filters": [{"field": "tag", "key": "lang", "relation": "=", "value": userLang}],
          "headings": { "en": this.headings[userLang] },
          "contents": { "en": this.contents[userLang] },
          priority: 10,
        }

        const push = axios.create({
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Basic " + config.onesignal_api[config.app.env]["rest_key"]
          }
        })

        push.post('https://onesignal.com/api/v1/notifications', data)
        .then( () => {
          Materialize.toast("Message sent to " + userLang.toUpperCase() + " users", 4000)
          this.headings.en = ''
          this.headings.ar = ''
          this.contents.en = ''
          this.contents.ar = ''
          this.isSending = false
        })
        .catch( () => {
          Materialize.toast("Message not sent to " + userLang.toUpperCase() + " users", 4000)
        })
      })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Admin/PushNotifications.vue